import angular from 'angular';
import _ from 'lodash';
import Logger from '../../../shared/logger';

const EmployersCache = {};

// eslint-disable-next-line import/prefer-default-export
export const EmployerService = (Restangular) => {
    const getEmployer = function (id) {
        return Restangular.one('employer', id)
            .get('')
            .catch((error) => Logger.error(error));
    };

    const getEmployerWallet = (id) => Restangular
        .one('employer', id)
        .all('wallet')
        .get('')
        .catch((error) => Logger.error(error));

    const getEmployers = function (projection = []) {
        return Restangular.all('employers')
            .post({ projection })
            .catch((error) => Logger.error(error));
    };

    const getAllEmployersForMenu = function () {
        return Restangular.all('employers')
            .post({ projection: ['name', 'office', 'status.current', 'settings.isResellerPartner'] })
            .catch((error) => Logger.error(error));
    };

    const getEmployersByIds = function (ids) {
        if (!_.isArray(ids) || !ids.length) {
            return [];
        }

        if (ids && ids.length === 1) {
            const emplId = _.first(ids);

            if (!EmployersCache[emplId]) {
                EmployersCache[emplId] = Restangular.all('employer')
                    .all('search')
                    .post({ employerIDs: [ids] })
                    .catch((error) => Logger.error(error));
            }

            return EmployersCache[emplId];
        }
        return Restangular.all('employer')
            .all('search')
            .post({ employerIDs: ids })
            .catch((error) => Logger.error(error));
    };

    const getEmployerWorkflowCounters = function (id, body) {
        return Restangular.one('employer', id)
            .all('workflowCounters')
            .post(body)
            .catch((error) => Logger.error(error));
    };

    const postEmployer = function (data) {
        return Restangular.all('employer')
            .post(data)
            .catch((error) => Logger.error(error));
    };

    const putEmployer = function (id, data) {
        return Restangular.one('employer', id)
            .customPUT(data)
            .catch((error) => Logger.error(error));
    };

    const activateEmployer = function (id) {
        return Restangular.one('employer', id)
            .all('activate')
            .customPUT('')
            .catch((error) => Logger.error(error));
    };

    const deactivateEmployer = function (id) {
        return Restangular.one('employer', id)
            .all('deactivate')
            .customPUT('')
            .catch((error) => Logger.error(error));
    };

    const getEmployersByPositionIds = function (body) {
        return Restangular.all('employer')
            .all('getByPositionIds')
            .post(body)
            .catch((error) => Logger.error(error));
    };

    const getSpecialtiesUpdateStatus = function (id) {
        return Restangular.one('employer', id)
            .all('getSpecialtiesUpdateStatus')
            .get('')
            .catch((error) => Logger.error(error));
    };

    const getReseller = function (employerId) {
        return Restangular.one('employer', employerId)
            .all('reseller')
            .get('')
            .catch((error) => Logger.error(error));
    };

    return {
        getEmployer,
        getEmployers,
        getAllEmployersForMenu,
        getEmployersByIds,
        getEmployerWorkflowCounters,
        postEmployer,
        putEmployer,
        activateEmployer,
        deactivateEmployer,
        getEmployerWallet,
        getEmployersByPositionIds,
        getSpecialtiesUpdateStatus,
        getReseller,
    };
};

angular.module('TALENYA-FE')
    .factory('EmployerService', EmployerService);
